import { formatFacetDisplayName, formatFilterLabel } from "@/lib/results-page-utils";

export interface SearchFacetBreadcrumb {
  id: string;
  facetName: string;
  groupLabel: string;
  label: string;
  value: string;
}

export interface SearchFacet {
  name: string;
  values: string[];
}

export function buildSearchFacetBreadcrumbs(facets: SearchFacet[]): SearchFacetBreadcrumb[] {
  return facets.flatMap((facet) =>
    facet.values.map((value) => ({
      id: `${facet.name}:${value}`,
      facetName: facet.name,
      value,
      label: formatFilterLabel(facet.name, value),
      groupLabel: formatSearchFacetName(facet.name),
    }))
  );
}

function formatSearchFacetName(facetName: string): string {
  if (facetName.startsWith("category_path.depth_")) {
    return "Category";
  }

  return formatFacetDisplayName(facetName);
}
